import React, {Component} from 'react';
import LoginAccountInput from "../LoginAccountInput";
import ImgCodeInput from "../ImgCodeInput";
import BsyBtn from "../BsyBtn";
import EntryInputCode from "../EntryInputCode";
import tipAlert from "../BsyAlertTip/Staticize";
import dingdingTeamEmptyImg from '../../images/img_wutuandui@2x.png'
import PubSub from "pubsub-js";
import './index.css'


class DingdingBind extends Component {
    state={
        dingdingBindShow : window.data_config.smdata.type,
        dingdingMobileCodeShow : false,
        dingdingTeamList : window.data_config.smdata.list || [],
        dingdingTeamUrl : "",
    }
    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }
    accountValue = (ref) =>{
        this.account = ref
    }
    sendCode = () =>{
        const mobile = this.account.getValue()
        const imgCode = this.imgCode.getValue()
        React.axios('/dingding/send_mobile_code',{
            "country_code": mobile.countryCode,  //地区编号
            "fly": imgCode.value,  //图形验证码
            "mobile": mobile.value  //手机号
        }).then(res =>{
            if(res.data.errcode===0){
                this.setState({
                    dingdingBindShow:false,
                    dingdingMobileCodeShow:true
                })
                PubSub.publish('codeCont',{value:mobile});
            }else{
                this.imgCode.changeCode()
                tipAlert({
                    type: "error",
                    msg : React.language(res.data.errmsg)
                })
            }
        }).catch(res=>{
            const res1 =  res.response ? res.response.data : res.data;
            this.imgCode.changeCode()
            if(res1.toString().indexOf('"Message":"OK"') === -1)
            {
                if(res1.toString().indexOf('code'))
                {
                    // tipAlert({
                    //     type: "error",
                    //     msg : res1.msg
                    // })
                }
                else
                {
                    // tipAlert({
                    //     type: "error",
                    //     msg : React.language("System.error")
                    // })
                }
            }else{
                this.setState({
                    dingdingBindShow:false,
                    dingdingMobileCodeShow:true
                })
                PubSub.publish('codeCont',{value:mobile});
            }
        })
    }
    dingdingMobileCode = (values, state, cd) =>{
        const {value} = state
        this.timer1 = setTimeout(()=>{
            React.axios('/dingding/bind_mobile',{
                "mobile":value,
                "code":values
            }).then(res =>{
                if(res.data.errcode===0){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    this.setState({
                        dingdingTeamList : res.data.data.list,
                        dingdingMobileCodeShow : false,
                        dingdingBindShow : res.data.data.type
                    })
                }else{
                    tipAlert({
                        type: "error",
                        msg : React.language(res.data.errmsg)
                    })
                }
            }).catch(res=>{
                const res1 =  res.response ? res.response.data : res.data;
                this.imgCode.changeCode()
                if(res1.toString().indexOf('"Message":"OK"') === -1)
                {
                    if(res1.toString().indexOf('code'))
                    {
                        // tipAlert({
                        //     type: "error",
                        //     msg : res1.msg
                        // })
                        cd && cd(!0, res1.msg);
                    }
                    else
                    {
                        // tipAlert({
                        //     type: "error",
                        //     msg : React.language("System.error")
                        // })
                        cd && cd(!0, React.language("System.error"));
                    }
                    
                }else{
                    tipAlert({
                        type: "success",
                        msg : res1.msg
                    })
                    this.setState({
                        dingdingTeamList : res1.data.data.list,
                        dingdingMobileCodeShow : false,
                        dingdingBindShow : res1.data.data.type
                    })
                }
            })
        },300)
    }

    selectTeam = (corpid, userid) =>{
        return (event) =>{
            const {dingdingBindShow} = this.state
            for(var i = 0; i<event.target.parentNode.childNodes.length;i++){
                event.target.parentNode.childNodes[i].classList.remove("select")
            }
            event.target.classList.add("select")
            let dingdingTeamUrl
            if(dingdingBindShow === 0 || dingdingBindShow === 2){
                dingdingTeamUrl = window.rootDirectroy +'/dingding/dd_mobile_sm?corpid='+corpid+'&dingding_userid='+userid
            }else if(dingdingBindShow === 1){
                dingdingTeamUrl = window.rootDirectroy +'/dingding/dd_corp_back?corpid='+corpid+'&dingding_userid='+userid
            }
            this.setState({
                dingdingTeamUrl
            })
        }
    }

    render() {
        const {dingdingBindShow, dingdingMobileCodeShow, dingdingTeamList, dingdingTeamUrl} = this.state
        return (
            <div className="DingdingBind">
                {dingdingBindShow === 0 && <div className="sendCodeDingDing">
                    <div className="title">
                        {React.language('account.signin.dingtalk')}
                    </div>
                    <LoginAccountInput value={this.account ? this.account.getValue().value : ""} mode="mobile" getValue={this.accountValue}/>
                    <ImgCodeInput getValue={this.imgCodeValue}/>
                    <BsyBtn onClick={this.sendCode} text={React.language('validCode.fetch')}/>
                </div>}
                {dingdingMobileCodeShow && <EntryInputCode mode="dingding" sendCode={this.sendCode} LoginCode={this.dingdingMobileCode}/>}
                {dingdingTeamList.length === 0 && ( dingdingBindShow === 1 ||  dingdingBindShow === 2 ) && <div className="dingding-emptyTeam">
                    <div className="img">
                        <img src={dingdingTeamEmptyImg} alt=""/>
                    </div>
                    <div className="emptyTip">
                        <p dangerouslySetInnerHTML={{__html: React.language('dingding.empty.team.tip')}}>

                        </p>
                    </div>
                </div>}
                {dingdingTeamList.length !== 0 && ( dingdingBindShow === 1 ||  dingdingBindShow === 2 ) && <div className="dingding-more-teams">
                    <div className="more-teams-title">
                        <p>
                            {React.language('dingding.have.teams.tip')}
                        </p>
                    </div>
                    <div className="more-teams-list">
                        <ul>
                            {
                                dingdingTeamList.map((val)=>{
                                    return <li className="item" onClick={this.selectTeam(val.corpid,val.dingding_userid)}>{val.corp_name}</li>
                                })
                            }
                        </ul>
                    </div>
                    <a href={dingdingTeamUrl} className="m-dingding-teamsNext-btn">
                        {React.language('nextStep')}
                    </a>
                </div>}
            </div>
        );
    }
}

export default DingdingBind;